module.exports = "/packs/007-5195b7d3680e52ad270fe8a8f30bcfba.jpg";